const convertJs = require("@/assets/js/convert")

const RateOptions = [{
  name: "Week",
  days: 7
}]

const MediaCategory = [{
  name: "Bus Shelter",
  Calculate (Obj) {
    return CalcGrossItemSum1(Obj)
  },
}, {
  name: "Bus Exterior",
  Calculate (Obj) {
    return CalcGrossItemSum1(Obj)
  },
}, {
  name: "Bus Interior",
  Calculate (Obj) {
    return CalcGrossItemSum1(Obj)
  },
}, {
  name: "Apps",
  Calculate (Obj) {
    return CalcGrossItemSum2(Obj)
  }
},
{
  name: "CalcGrossItemSum1",
  Calculate (Obj) {
    return CalcGrossItemSum1(Obj)
  }
},
{
  name: "CalcGrossItemSum2",
  Calculate (Obj) {
    return CalcGrossItemSum2(Obj)
  }

}
]

const getUnitRate = (MediaRateOption) => {
  const RateOption = RateOptions.find(t => MediaRateOption.indexOf(t.name) >= 0)

  var val = 1;
  //改为grossRate每周金额,此代码注释
  // var Rates = MediaRateOption.split(' ')
  // if (Rates.length > 0) {
  //   Rates.map(t => {
  //     if (!isNaN(parseInt(t))) {
  //       val = parseInt(t) || 1
  //     }
  //   })
  // }


  return val * (RateOption?.days || 0)
}


const CalcGrossItemSum1 = (Obj) => {
  const Loading = (Obj.loading || 0) / 100 + 1

  const grossRate = convertJs.convertDecimal(Obj.grossRate)
  const unitRate = convertJs.convertDecimal(Obj.unitRate)
  const unitQty = convertJs.convertDecimal(Obj.unitQty)
  const noOfDays = convertJs.convertDecimal(Obj.noOfDays)
  const quantity = convertJs.convertDecimal(Obj.quantity)

  return convertJs.convertDecimal(grossRate * Loading / unitRate / unitQty * noOfDays * quantity)
}

const CalcGrossItemSum2 = (Obj) => {
  const Loading = (Obj.loading || 0) / 100 + 1

  const grossRate = convertJs.convertDecimal(Obj.grossRate)
  const quantity = convertJs.convertDecimal(Obj.quantity)
  const inventoryDeduction = Obj?.inventoryDeduction || 1;

  return convertJs.convertDecimal(grossRate / inventoryDeduction * Loading * quantity)
}

module.exports = {
  CalcGrossItemSum (Obj) {
    var name = Obj.category

    if ((Obj?.rateOption?.indexOf("IMP") >= 0 && Obj?.planName === "CMP") || name === "Apps") {
      name = "CalcGrossItemSum2"
    } else {
      name = "CalcGrossItemSum1"
    }

    const Event = MediaCategory.find(t => t.name === name) || false;

    if (Event) {
      return Event.Calculate(Obj)
    }
    return 0;
  }, getUnitRate (RateOption) {
    return getUnitRate(RateOption)
  }, unitGrossRate_str (alias) {
    const formatterJs = require('@/assets/js/formatter')

    const unit_str = formatterJs.formatterRate(alias)
    if (unit_str) {
      return `(${unit_str})`
    }
    return ""
  }
}
